import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Radio, Tooltip, Tag
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { 
    getMacEnrollmentSetting, addOrUpdateMacEnrollmentSettingBasicInfo, getSettingWiFiList
} from "../../axios/api.enroll"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    settingId: string,
    updateSetting: () => void,
}

export const EnrollmentSettingBasicInfo = (props: propsModel) => {
    const { settingId, updateSetting } = props;
    const [dataForm] = Form.useForm();
    const [returnToService, setReturnToService] = useState<boolean>(false);
    const { t } = useTranslation();
    const [wifiList, setWiFiList] = useState<any[]>([]);

    useEffect(() => {
        
        getDataInfo();
    }, [])

    const getDataInfo = () => {
        if(settingId)
        {
            Promise.all([getMacEnrollmentSetting(settingId), getSettingWiFiList()]).then(([res, wifis]) => {
                if (res && res != null) {
                    var data: any = {};
                    data.name = res.name;
                    data.status = res.status;
                    data.isReturnToService = res.isReturnToService;
                    setReturnToService(data.isReturnToService);
                    data.wifi = res.wiFiId;
                    dataForm?.setFieldsValue(data);
                }

                if(wifis)
                    setWiFiList(wifis);
            });
        }
    }
    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                var req: any = {};
                req.id = settingId;
                req.name = res.name;
                req.status = res.status;
                req.isReturnToService = res.isReturnToService;
                req.wiFiId = res.wifi;
                addOrUpdateMacEnrollmentSettingBasicInfo(req).then(() => {
                    notification.success({ message: t("成功") });
                    //dataForm.resetFields();
                    getDataInfo();
                })
            })
    }
    const cancelClick = () => {
        dataForm?.resetFields();
        updateSetting();
        getDataInfo();
    }

    return (<>
        <div>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>       
                <Form
                    style={{ width: "90%", marginTop: 36 }}
                    layout="horizontal"
                    form={dataForm}
                    labelCol={{ span: 4 }}
                    initialValues={{status: "Active",isReturnToService: false}}
                >
                    <Form.Item
                        label={t("注册预配置名称")}
                        name="name"
                        rules={[{ required: true, message: t("请输入注册预配置名称") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t("状态")}
                        name="status"
                        rules={[
                            { 
                            required: true, 
                            message: t("请选择状态") 
                            }
                        ]}
                    >
                        <Select>
                            <Select.Option value="Active">{t("启用")}</Select.Option>
                            <Select.Option value="Disabled">{t("禁用")}</Select.Option>
                        </Select>
                    </Form.Item>
                    <Item label={t("抹除后自动激活")} name="isReturnToService">
                        <Select style={{width:"50%"}} onChange={(key: boolean) => {
                            setReturnToService(key);
                        }}>
                            <Select.Option value={false}>{t("暂不设置")}</Select.Option>
                            <Select.Option value={true}>{t("设置")}</Select.Option>
                        </Select>
                    </Item>
                    {returnToService && <>
                        <Item 
                            label={t("WiFi")} 
                            name="wifi"
                            style={{paddingLeft:"100px"}}
                            rules={[{ required: true }]}
                        >
                            <Select 
                                style={{width:"50%"}}
                                options={wifiList.map(item => ({ label: item.name, value: item.id }))}
                            >
                            </Select>
                        </Item>
                    </>}
                </Form>
                <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                    <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                    <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { cancelClick(); }}>{t("取消")}</Button>
                </div>
            </Row>
        </div>

    </>)
};